import { useContext } from 'react';
import { BannerContext } from '../providers/BannerProvider';

/**
 * useSystemBanner — fires a system banner from anywhere under the
 * <BannerProvider>. Returns `{ showBanner, dismissBanner }`.
 *
 * Throws when used outside the provider — a missing provider is a wiring
 * bug, not a runtime fallback.
 */
export function useSystemBanner() {
  const ctx = useContext(BannerContext);
  if (ctx === null) {
    throw new Error(
      'useSystemBanner must be used within a <BannerProvider>',
    );
  }
  return { showBanner: ctx.showBanner, dismissBanner: ctx.dismissBanner };
}

export default useSystemBanner;
